import Vue from 'vue'
import moment from 'moment'

/**
 * directive: 日付の差分を指定のフォーマットに変更する
 * @param { String } data-start - 開始時間
 * @param { String } data-end - 終了時間
 * @param { String } data-format - 出力フォーマット
 * <span v-date-diff="hh時間mm分"
 *  data-start="2018-02-02 21:00:00"
 *  data-end="2018-02-02 23:59:59"
 *  data-format="HH時MM分"
 * ></span>
 * => 1時間59分
 */
Vue.directive('date-diff', {
  bind(el, binding) {
    const date = moment(el.textContent)
    const start = el.dataset.start
    const end = el.dataset.end
    const format = el.dataset.format
    const diff = moment(start).diff(moment(end))
    const duration = moment.duration(diff)

    let years, days, hrs, mins, secs
    if (diff < 0) {
      years = Math.abs(duration.years())
      days = Math.abs(duration.days())
      hrs = Math.abs(duration.hours())
      mins = Math.abs(duration.minutes())
      secs = Math.abs(duration.seconds())
    } else {
      years = days = hrs = mins = secs = 0
    }
    const replacedText = format
      .replace(/YY|yy/, years)
      .replace(/DD|dd/g, days)
      .replace(/HH|hh/g, hrs)
      .replace(/MM|mm/g, mins)
      .replace(/SS|ss/g, secs)

    Object.assign(el, {
      textContent: replacedText
    })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/datediff.js